import {
  CAlert,
  CButton,
  CCol,
  CDatePicker,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CTimePicker,
} from '@coreui/react-pro'
import moment from 'moment'
import React, { useRef, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import RoundService from 'src/service/RoundService'
import ToastComponent from 'src/components/common/TaostComponent'
import { Link, useNavigate } from 'react-router-dom'
const AddForm = (props) => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const validationSchema = Yup.object().shape({
    round: Yup.number().required('round is required'),
    start_date: Yup.date().required('Start Date is required'),
    end_date: Yup.date().required('End Date to is required'),
    start_time: Yup.string().required('Start Time to is required'),
    end_time: Yup.string().required('End Time to is required'),
  })
  const logoRef = useRef()

  const handleReset = (values, formikBag) => {
    logoRef.current.value = null //THIS RESETS THE FILE FIELD
  }
  const [errorMessages, setErrorMessages] = useState([])
  const formik = useFormik({
    initialValues: {
      round: props.roundNumber,
      start_date: '',
      end_date: '',
      start_time: '',
      end_time: '',
    },
    enableReinitialize: true,
    validationSchema,
    handleReset: handleReset,
    onSubmit: (data, actions) => {
      actions.resetForm({
        values: {
          round: '',
        },
      })

      data.start_date = moment(startDate).format('YYYY-MM-DD')
      data.end_date = moment(endDate).format('YYYY-MM-DD')
      data.start_time = lockoutStartTime
      data.end_time = lockoutEndTime
      setLoader(true)
      RoundService.saveRound(data)
        .then((res) => {
          if (res.status === 200) {
            setErrorMessages([])
            props.fetchUsers()
            ToastComponent(res.message, 'success')
            setLoader(false)
            formik.resetForm()
          } else {
            const errors =
              res.errors && Array.isArray(res.errors)
                ? res.errors
                : [res.message || 'Something went wrong.']
            setErrorMessages(errors) // Update error messages
            setLoader(false)
          }
        })
        .catch((e) => {
          console.log('Error: ', e)
          ToastComponent('Something went wrong. Please try again.', 'error')
          setLoader(false)
        })
    },
  })
  const [formValues, setformValues] = useState(formik.initialValues)
  const [startDate, setStartDate] = useState(null)
  const [minEndDate, setMinEndDate] = useState(new Date())
  const [endDate, setEndDate] = useState(null)
  const [lockoutStartTime, setLockoutStartTime] = useState(null)
  const [lockoutEndTime, setLockoutEndTime] = useState(null)
  const handleStartDate = (date) => {
    setStartDate(date)
    setMinEndDate(date)
    setEndDate(null) // important: null instead of ''
  }

  const handleEndDate = (date) => {
    setEndDate(date)
  }

  const handleLockoutStartTime = (event) => {
    const dateFormat = moment(event, 'HH:mm').format('HH:mm')
    setLockoutStartTime(dateFormat)
  }

  const handleLockoutEndTime = (event) => {
    const dateFormat = moment(event, ['HH:mm']).format('HH:mm')
    setLockoutEndTime(dateFormat)
  }
  const todayDate = new Date()
  const lastDate = minEndDate
  const minDate = todayDate.setDate(todayDate.getDate() - 1)
  const minasdasDate = lastDate.setDate(lastDate.getDate())

  const formatTime = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return ''

    let hours = date.getHours()
    const minutes = date.getMinutes()

    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12 || 12

    const formattedMinutes = minutes.toString().padStart(2, '0')

    return `${hours}:${formattedMinutes} ${ampm}`
  }
  return (
    <>
      {errorMessages.length > 0 && (
        <div className="error-list">
          {errorMessages.map((error, index) => (
            <>
              {/* <li key={index}>{error}</li> */}
              <CAlert color="danger" key={index}>
                {error}
              </CAlert>
            </>
          ))}
        </div>
      )}
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CCol md={12}>
          <CFormLabel className="fw-bold" htmlFor="grade">
            Round{' '}
          </CFormLabel>
          <CFormInput
            placeholder="Round"
            className={
              'form-control' + (formik.errors.round && formik.touched.round ? ' is-invalid' : '')
            }
            defaultValue={props.roundNumber}
            // onChange={formik.handleChange}
            aria-label="round"
            id="round"
            name="round"
            disabled
          />
          {formik.errors.round && formik.touched.round && (
            <CFormFeedback invalid>{formik.errors.round}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="grade">
            Round Start Date *
          </CFormLabel>
          <CDatePicker
            date={startDate}
            onDateChange={(e) => {
              handleStartDate(e)
              formik.setFieldValue('start_date', moment(e).format('YYYY-MM-DD'))
            }}
          />

          {formik.errors.start_date && formik.touched.start_date && (
            <CFormFeedback invalid>{formik.errors.start_date}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="grade">
            Round Start Time *
          </CFormLabel>
          <CTimePicker
            locale="en-US"
            value={lockoutEndTime}
            seconds={false}
            // onTimeChange={handleLockoutStartTime}
            className={formik.errors.start_time && formik.touched.start_time ? 'is-invalid' : ''}
            onTimeChange={(e) => {
              handleLockoutStartTime(e)
              formik.setTouched({
                ...formik.touched,
                start_time: true,
              })
              formik.setFieldValue('start_time', moment(e).format('YYYY-MM-DD'))
            }}
            // ampm={false}
          />

          {formik.errors.start_time && formik.touched.start_time && (
            <CFormFeedback invalid>{formik.errors.start_time}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="grade">
            Round End Date *
          </CFormLabel>
          <CDatePicker
            date={endDate}
            minDate={startDate}
            onDateChange={(e) => {
              handleEndDate(e)
              formik.setFieldValue('end_date', moment(e).format('YYYY-MM-DD'))
            }}
          />
          {formik.errors.end_date && formik.touched.end_date && (
            <CFormFeedback invalid>{formik.errors.end_date}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="grade">
            Round End Time *
          </CFormLabel>
          <CTimePicker
            className={formik.errors.end_time && formik.touched.end_time ? 'is-invalid' : ''}
            locale="en-US"
            value={lockoutEndTime}
            seconds={false}
            onTimeChange={(e) => {
              handleLockoutEndTime(e)
              formik.setTouched({
                ...formik.touched,
                end_time: true,
              })
              formik.setFieldValue('end_time', moment(e).format('YYYY-MM-DD'))
            }}
            // ampm={false}
          />
          {formik.errors.end_time && formik.touched.end_time && (
            <CFormFeedback invalid>{formik.errors.end_time}</CFormFeedback>
          )}
        </CCol>

        <CCol md={4}>
          <CLoadingButton
            type="submit"
            color="success"
            variant="outline"
            loading={loader}
            id="submit"
          >
            Submit
          </CLoadingButton>
          &nbsp;&nbsp;
          <CButton color="primary" variant="outline" component={Link} to="/round-import">
            Import
          </CButton>
        </CCol>
      </CForm>
    </>
  )
}

export default AddForm
